import { noop } from '@deltasierra/utilities-object';
import { Theme, createGenerateClassName, CssBaseline, MuiThemeProvider, StylesProvider } from '@material-ui/core';
import * as React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { LegacyDarkTheme } from './LegacyDarkTheme';
import { LegacyLightTheme } from './LegacyLightTheme';
import { ThemeName, ThemeNameContextValue } from './ThemeProvider';

const themes: Record<ThemeName, Theme> = { dark: LegacyDarkTheme, light: LegacyLightTheme };
export const LegacyThemeNameContext = React.createContext<ThemeNameContextValue>({
    setThemeName: noop,
    themeName: 'light',
});

export type LegacyThemeProviderProps = {
    children?: React.ReactNode;
    productionPrefix?: string;
};
export const LegacyThemeProvider: React.FC<LegacyThemeProviderProps> = ({ children, productionPrefix }) => {
    const [themeName, setThemeName] = React.useState<ThemeName>('light');

    const generateClassName = createGenerateClassName({ productionPrefix });

    return (
        <LegacyThemeNameContext.Provider value={{ setThemeName, themeName }}>
            <StylesProvider generateClassName={generateClassName} injectFirst>
                <MuiThemeProvider theme={themes[themeName]}>
                    <StyledThemeProvider theme={themes[themeName]}>
                        <CssBaseline />
                        {children}
                    </StyledThemeProvider>
                </MuiThemeProvider>
            </StylesProvider>
        </LegacyThemeNameContext.Provider>
    );
};
LegacyThemeProvider.displayName = 'ThemeProvider';
